import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

type TDeleteBudgetFile = {
    attachmentId: string;
    budgetId: string;
};

export default async ({ attachmentId, budgetId }: TDeleteBudgetFile) => {
    const tempHeaders = {
        auth: true,
    };

    const httpRequest = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/budget/${budgetId}/attachment/${attachmentId}`,
        method: "delete",
        headers: tempHeaders,
    });
    const { body, statusCode } = httpRequest;

    return handleStatusCases({ body, statusCode });
};
